import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import Paragraph from "../typography/Paragraph"
import './CheckList.scss'

const CheckListItem = ({ className, children }) => (
    <li className={cx('check-list-item', className)}>
        {children}
    </li>
)

CheckListItem.propTypes = {
}

export default CheckListItem



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/CheckList/CheckListItem.jsx